import { gql } from '@apollo/client';

export const FETCH_LOCATIONS_LOG = gql`
	query GetCrewMemberHomeBases($crewMemberId: ID!) {
		crewMemberHomeBases(crewMemberId: $crewMemberId) {
			currentTemporaryHomeBaseId
			currentPermanentHomeBaseId
			homeBases {
				id
				effectiveTimestamp
				expireTimestamp
				city {
					name
				}
			}
		}
	}
`;
